
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "introducing-the-blog"
    }}>{`Introducing the Blog!`}</h1>
    <p>{`We’re excited to announce the VCC UI Blog: An ongoing effort to publish information regarding updates in VCC UI to a wider audience. This will allow us to have a more effective channel of communication to everyone, including our external consumers.`}</p>
    <p>{`You'll be able to subscribe to updates via RSS and Email.`}</p>
    <p>{`Apart from update this blog will also feature tutorials and explanations regarding design decisions and overall architecture of VCC UI and the upcoming Volvo Cars Design System.`}</p>
    <p>{`Stay tuned!`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;